"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LigiLogistics = void 0;
exports.LigiLogistics = {
    id: 'LigiLogistics',
    companyName: 'Ligi Logistics',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'LigiLogistics',
    },
    isInternal: false,
    isActive: true,
    countries: ['IN'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGlnaUxvZ2lzdGljcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9MaWdpTG9naXN0aWNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsYUFBYSxHQUFVO0lBQ2hDLEVBQUUsRUFBRSxlQUFlO0lBQ25CLFdBQVcsRUFBRSxnQkFBZ0I7SUFDN0IsY0FBYyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztJQUM5QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsZUFBZTtLQUN6QjtJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==